export default "__VITE_ASSET__50596a31__"